// Re-export shared error utility for backward compatibility
export { extractApiError as extractError } from '../../utils/apiError';

export const CAMERA_TYPE_OPTIONS = [
  { value: 'trassir_mjpeg', label: 'Trassir MJPEG' },
  { value: 'trassir_rtsp', label: 'Trassir RTSP' },
  { value: 'ws_ipeye', label: 'IPeye (WS)' },
  { value: 'hik_snapshot', label: 'Hikvision Snapshot' },
  { value: 'hik_rtsp', label: 'Hikvision RTSP' },
  { value: 'rtmp', label: 'RTMP' },
  { value: 'rtsp', label: 'RTSP' },
  { value: 'ezviz', label: 'EZVIZ' },
];

export function cameraTypeLabel(type: string): string {
  return CAMERA_TYPE_OPTIONS.find(o => o.value === type)?.label ?? type;
}
